import { CurrencyLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import {
  useCurrencyBannerMediaFallbackFragment,
  useCurrencyBannerMediaFragment,
} from "@/components/currencies/use-currency-banner-media"

export const TokenRewardMediaFragment = graphql(
  `
    fragment TokenRewardMedia on UserTokenReward {
      id
      balance {
        usdValue
        currency {
          imageUrl
          ...CurrencyLockup
          ...useCurrencyBannerMedia
          ...useCurrencyBannerMediaFallback
        }
      }
    }
  `,
  [
    CurrencyLockupFragment,
    useCurrencyBannerMediaFragment,
    useCurrencyBannerMediaFallbackFragment,
  ],
)
